import BuilderNumericalMenu from '../../../BuilderFields/BuilderNumericalMenu';
import { getOptionsByTimeUnit } from './utils';
import styled from 'styled-components';
import { NumberInputField } from '../../../../Form';
import TimeUnitPicker from '../TimeUnitPicker';
import { IDatePickerProps } from './types';

const NumberInput = styled(NumberInputField)`
  width: 100px;
  > input {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;

const DatePickerLast = ({
  datePicker,
  onChange,
}: IDatePickerProps<'DatePickerLast'>) => {
  const options = getOptionsByTimeUnit(datePicker.unit);
  return (
    <Container>
      <BuilderNumericalMenu
        label="Last"
        value={datePicker.period}
        options={options}
        placeholder="Enter a value"
        min={1}
        onChange={(newValue) => {
          onChange({
            __typename: 'DatePickerLast',
            period: newValue,
            unit: datePicker.unit,
          });
        }}
        trigger={
          <NumberInput
            placeholder="eg. 5"
            value={datePicker.period}
            min={1}
            readOnly
          />
        }
        menuWidth={100}
      />
      <TimeUnitPicker
        value={datePicker.period}
        timeUnit={datePicker.unit}
        onChange={(newValue) => {
          onChange({
            __typename: 'DatePickerLast',
            period: datePicker.period,
            unit: newValue,
          });
        }}
      />
    </Container>
  );
};

export default DatePickerLast;
